// src/layout/CollapsibleLayout.jsx
import { Box, CssBaseline, Toolbar, useMediaQuery } from "@mui/material";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";
import useLayoutStore from "../store/useLayoutStore";
import { useTheme } from "@mui/material/styles";

const CollapsibleLayout = () => {
  const { isSidebarOpen } = useLayoutStore();
  const theme = useTheme();

  // ✅ Breakpoints
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // <600
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600–899
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg")); // 900–1199
  const isDesktop = useMediaQuery(theme.breakpoints.between("lg", "xl")); // 1200–1535
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("xl")); // ≥1536

  // ✅ Chiều rộng Sidebar theo từng loại màn hình
  let drawerW = 0;
  if (isMobile) {
    drawerW = 0; // overlay
  } else if (isTablet) {
    drawerW = 200;
  } else if (isLaptop) {
    drawerW = isSidebarOpen ? 240 : 80;
  } else if (isDesktop) {
    drawerW = isSidebarOpen ? 280 : 100;
  } else if (isLargeScreen) {
    drawerW = isSidebarOpen ? 320 : 120;
  }

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: "background.default",
      }}
    >
      <CssBaseline />

      {/* Sidebar */}
      <Sidebar />

      {/* Nội dung chính */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: isMobile || isTablet ? "100vw" : `calc(100vw - ${drawerW}px)`,
          minHeight: "100vh",
          overflow: "hidden",
          transition: "width 0.3s",
        }}
      >
        <Header /> {/* Header nằm trên */}
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};

export default CollapsibleLayout;
